/**
 * IP18 Gear — Part 2 pill tabs hard-cut image + copy (sync with swiper).
 * Cover: transparent while overlapping the pinned Inspire stage, solid after.
 */
(function () {
  'use strict';

  function bindSolid(section) {
    if (!section || section._ip18GearSolid) return;
    section._ip18GearSolid = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function update() {
      if (reduce.matches || !document.querySelector('ip18-inspire-pin.is-pin')) {
        section.classList.add('is-solid');
        return;
      }
      section.classList.toggle('is-solid', section.getBoundingClientRect().top <= 0);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if (reduce.addEventListener) reduce.addEventListener('change', update);
    update();
  }

  function scanSolid() {
    document.querySelectorAll('.ip18-gear').forEach(bindSolid);
  }

  class Ip18GearLights extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      bindSolid(this.closest('.ip18-gear'));
      this._tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ip18-gear-tab]'));
      this._bodies = Array.prototype.slice.call(this.querySelectorAll('[data-ip18-gear-body]'));
      this._onClick = this._onClick.bind(this);
      this._onReady = this._onReady.bind(this);
      this.addEventListener('click', this._onClick);
      document.addEventListener('swiper-component:ready', this._onReady);
      this._bindSwiper(this._swiperFromEl());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('swiper-component:ready', this._onReady);
    }

    _swiperFromEl() {
      var component = this.querySelector('swiper-component');
      return component && component.swiper ? component.swiper : null;
    }

    _onReady(event) {
      var detail = event.detail;
      if (!detail || !detail.swiperComponent || !this.contains(detail.swiperComponent)) return;
      this._bindSwiper(detail.swiper);
    }

    _bindSwiper(swiper) {
      if (!swiper || swiper._ip18GearBound) return;
      swiper._ip18GearBound = true;
      this._swiper = swiper;
      this._sync(swiper.realIndex || swiper.activeIndex || 0);
      var self = this;
      swiper.on('slideChange', function () {
        self._sync(swiper.realIndex || swiper.activeIndex || 0);
      });
    }

    _onClick(event) {
      var tab = event.target.closest('[data-ip18-gear-tab]');
      if (!tab || !this.contains(tab)) return;
      var index = Number(tab.getAttribute('data-index'));
      if (isNaN(index)) return;
      if (this._swiper && typeof this._swiper.slideTo === 'function') {
        this._swiper.slideTo(index);
      } else {
        this._sync(index);
      }
    }

    _sync(index) {
      this._tabs.forEach(function (el) {
        var on = Number(el.getAttribute('data-index')) === index;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.tabIndex = on ? 0 : -1;
      });
      this._bodies.forEach(function (el) {
        var on = Number(el.getAttribute('data-index')) === index;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
      });
    }
  }

  if (!customElements.get('ip18-gear-lights')) {
    customElements.define('ip18-gear-lights', Ip18GearLights);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanSolid);
  } else {
    scanSolid();
  }
})();
